import FontFaceObserver from 'fontfaceobserver';

interface FontConfig {
  family: string;
  weight?: number | string;
  style?: string;
  timeout?: number;
}

class FontLoader {
  private defaultTimeout = 3000;
  private fonts: FontConfig[] = [
    { family: 'Kiwi Maru', weight: 300 },
    { family: 'Kiwi Maru', weight: 400 },
    { family: 'Kiwi Maru', weight: 500 },
    { family: 'Dancing Script', weight: 400 },
    { family: 'Dancing Script', weight: 600 },
    { family: 'Dancing Script', weight: 700 },
  ];

  async loadFonts(): Promise<void> {
    const fontObservers = this.fonts.map(font => {
      const observer = new FontFaceObserver(font.family, {
        weight: font.weight,
        style: font.style || 'normal'
      });
      
      return observer.load(null, font.timeout || this.defaultTimeout)
        .then(() => {
          document.documentElement.classList.add(`${font.family.toLowerCase().replace(/\s+/g, '-')}-loaded`);
          if (font.weight) {
            document.documentElement.classList.add(`${font.family.toLowerCase().replace(/\s+/g, '-')}-${font.weight}-loaded`);
          }
        })
        .catch(() => {
          console.warn(`Failed to load font: ${font.family} ${font.weight || ''}`);
        });
    });

    try {
      await Promise.all(fontObservers);
      document.documentElement.classList.add('fonts-loaded');
      localStorage.setItem('fontsLoaded', 'true');
    } catch (error) {
      console.warn('Some fonts failed to load, using fallback fonts');
      document.documentElement.classList.add('fonts-fallback');
    }
  }

  checkCachedFonts(): boolean {
    return localStorage.getItem('fontsLoaded') === 'true';
  }

  initializeFonts(): void {
    if (this.checkCachedFonts()) {
      document.documentElement.classList.add('fonts-loaded');
      document.documentElement.classList.add('fonts-cached');
    }

    if (document.readyState === 'complete') {
      this.loadFonts();
    } else {
      window.addEventListener('load', () => this.loadFonts());
    }
  }
}

export const fontLoader = new FontLoader();